<div class="dosage-unit-manage-list">
  <div class="dosage-unit-manage-list__toolbar">
    <mat-form-field appearance="outline" class="dosage-unit-manage-list__search" subscriptSizing="dynamic">
      <mat-label>Search dosage units</mat-label>
      <input matInput type="text" [formControl]="searchControl" placeholder="Search dosage units" />
      <mat-icon matPrefix>search</mat-icon>
      @if (isSearching) {
        <mat-hint>Searching...</mat-hint>
      }
    </mat-form-field>
    <button type="button" mat-stroked-button class="dosage-unit-manage-list__create" (click)="createDosageUnit()">
      <mat-icon>add</mat-icon>
      Create
    </button>
  </div>

  <div class="dosage-unit-manage-list__items">
    @for (unit of dosageUnits; track unit.id) {
      <div class="dosage-unit-manage-list__row">
        <span>{{ unit.unit }}</span>
        <button type="button" (click)="deleteDosageUnit(unit)" mat-stroked-button class="dosage-unit-manage-list__delete">
          Delete
        </button>
      </div>
    } @empty {
      <p class="dosage-unit-manage-list__empty">No dosage units found.</p>
    }
  </div>
</div>
